import * as Victory from 'victory';
export default Victory;
